import React, { useEffect, useState } from 'react';
import { SubirArchivo } from '../../../componentes/formulariosFormik/SubirArchivo';
import {LoaderCircular} from '../../../componentes/LoaderCircular'

export const ArchivosAdjuntos = ({ analiticoFile,
                                    setAnaliticoFile,
                                    dniFrenteFile,
                                    setDniFrenteFile,
                                    dniReversoFile,
                                    setDniReversoFile,
                                    foto4x4File,
                                    setFoto4x4File,
                                    antecedentes_penFile,
                                    setAntecedentesPenFile,
                                    certificadoMatrimonioFile,
                                    setCertificadoMatrimonioFile,
                                    otroArchivo,
                                    setOtroArchivo,
                                    objetoDinamico,
                                    loadingFile }) => {
        return   <section>
                   {loadingFile && <LoaderCircular />}
    
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      <div className="p-4 bg-slate-50 rounded-2xl border border-dashed border-slate-300 transition-all hover:bg-white hover:border-blue-300">
                        <SubirArchivo 
                          titulo="Analítico Estudios Teológicos (PDF)*" 
                          texto={!analiticoFile ? "" : ''}
                          file={analiticoFile} 
                          tiposFiles={['.pdf']} 
                          maximo={5000000} 
                          setFile={setAnaliticoFile} 
                        />
                      </div>
                      <div className="p-4 bg-slate-50 rounded-2xl border border-dashed border-slate-300 transition-all hover:bg-white hover:border-blue-300">
                        <SubirArchivo 
                          titulo="Foto DNI Frente (JPG/PNG)*" 
                          file={dniFrenteFile} 
                          texto={!dniFrenteFile ? "" : ''}
                          maximo={500000} 
                          tiposFiles={['.png', '.jpg', '.jpeg']} 
                          setFile={setDniFrenteFile} 
                        />
                      </div>
                      <div className="p-4 bg-slate-50 rounded-2xl border border-dashed border-slate-300 transition-all hover:bg-white hover:border-blue-300">
                        <SubirArchivo 
                          titulo="Foto DNI Reverso (JPG/PNG)*" 
                          file={dniReversoFile} 
                          texto={!dniReversoFile ? "" : ''}
                          maximo={500000} 
                          tiposFiles={['.png', '.jpg', '.jpeg']} 
                          setFile={setDniReversoFile} 
                        />
                      </div>
                      <div className="p-4 bg-slate-50 rounded-2xl border border-dashed border-slate-300 transition-all hover:bg-white hover:border-blue-300">
                        <SubirArchivo 
                          titulo="Foto 4x4 Profesional (JPG/PNG)*" 
                          file={foto4x4File} 
                          texto={!foto4x4File ? "" : ''}
                          maximo={500000} 
                          tiposFiles={['.png', '.jpg', '.jpeg']} 
                          setFile={setFoto4x4File} 
                        />
                      </div>
                      <div className="p-4 bg-slate-50 rounded-2xl border border-dashed border-slate-300 transition-all hover:bg-white hover:border-blue-300">
                        <SubirArchivo 
                          titulo="Antecedentes Penales (PDF)*" 
                          file={antecedentes_penFile} 
                          texto={!antecedentes_penFile ? "" : ''}
                          maximo={5000000} 
                          tiposFiles={['.pdf']} 
                          setFile={setAntecedentesPenFile} 
                        />
                      </div>
                      <div className="p-4 bg-slate-50 rounded-2xl border border-dashed border-slate-300 transition-all hover:bg-white hover:border-blue-300">
                        <SubirArchivo 
                          titulo="Archivo Extra (Opcional)" 
                          file={otroArchivo} 
                          opcional={true} 
                          texto={!otroArchivo ? "" : ''}
                          tiposFiles={['.pdf']} 
                          maximo={5000000} 
                          setFile={setOtroArchivo} 
                        />
                      </div>
    
                      {(objetoDinamico?.estado_civil?.id === 3 || objetoDinamico?.estado_civil?.id === 6) && (
                        <div className="p-4 bg-pink-50 rounded-2xl border border-dashed border-pink-200 lg:col-span-3">
                          <SubirArchivo 
                            titulo="Certificado de Matrimonio (PDF)*" 
                            file={certificadoMatrimonioFile}
                            texto={!certificadoMatrimonioFile ? "" : ''}
                            tiposFiles={['.pdf']} 
                            maximo={5000000} 
                            setFile={setCertificadoMatrimonioFile} 
                          />
                        </div>
                      )}
                    </div>
                  </section>

};